import React, { useEffect, useState } from "react";
import SuperLayout from "./SuperLayout";
import BackDropLoading from 'Components/BackDropLoading2/BackDropLoading';
import Header from "./components/Header/Header";
import SideDrawer from "./components/SideDrawer/SideDrawer";
import { CssBaseline } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import { isSuperAdmin } from "Helpers/analyzeToken";
import { push } from "Helpers/History";


export default function Index(props) {
  const { rtlLayout, isLoggedIn, userData} = useSelector(state => ({
    rtlLayout: state.settings.rtlLayout,
    isLoggedIn: state.auth.isLoggedIn,
    userData: state.auth.userData,
  }))
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if(isSuperAdmin()) {
      setLoading(true);
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey")
      };
      dispatch(getUserData(params));
      setLoading(false);
    } else {
      push('/dashboard')
    }
  },[isLoggedIn])

  return (
    <>
      {
        userData ? (
          <SuperLayout >
            <CssBaseline />
            <div className="adminLayout">
              <Header rtlLayout={rtlLayout} name={userData.Name}/>
              <SideDrawer />
              <main className={`content rtl-${rtlLayout}`}>
                {props.children}
              </main>
            </div>
          </SuperLayout>
        ) : <BackDropLoading loading={loading}/>
      }
    </>
  );
}
